module.exports = __webpack_public_path__ + "static/media/corona-dashboard.e6ad534b.jpg";